import { createAmplitudePlugin } from '../plugins/AmplitudePlugin';
export class HoneypotBase {
    amplitudePlugin(pluginConfig) {
        return createAmplitudePlugin(this.track.bind(this), this.get.bind(this), this.identify.bind(this), pluginConfig);
    }
}
